import CenterForm from "./CenterForm";
import { CommonTexts } from "locale/es";
import { Box } from "@mui/material";
import DrawerHeader from "components/DrawerHeader";
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import { useSelector } from "react-redux";
import Loader from "components/Loader/Loader";
import { updateUserCenterAction } from "redux/reducers/userAuthenticationReducer";

export function DisplayEditSelectedCenterDetails() {
  const { data, loading } = useSelector(({ center }) => center);

  return (
    <Box pt={4} pb={12} px={3} width="100%">
      <DrawerHeader />
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <BreadCrumbs
          name={`${CommonTexts.CENTERS} / ${data?.name}`}
          icon={<AddBusinessIcon sx={{ mr: 0.5 }} fontSize='inherit' />}
          mb={2}
        />
      </Box>
      <Box sx={{
        mx: "auto"
      }}
      >
        {loading
          ? <Loader message="Cargando detalles del centro" />
          : <CenterForm
            selectedCenter={data}
            onSubmit={updateUserCenterAction}
          />
        }
      </Box>
    </Box>

  )
}